import { createContext, useContext } from 'react';

export const ImageLoadingContext = createContext({
  shouldUseLQIP: false, // Low Quality Image Placeholder
});

ImageLoadingContext.displayName = 'ImageLoadingContext';

export const useImageLoadingContext = () => useContext(ImageLoadingContext);
